import { render, staticRenderFns } from "./VuesticScrollbar.vue?vue&type=template&id=01689698"
import script from "./VuesticScrollbar.vue?vue&type=script&lang=js"
export * from "./VuesticScrollbar.vue?vue&type=script&lang=js"
import style0 from "./VuesticScrollbar.vue?vue&type=style&index=0&id=01689698&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-scrollbar/VuesticScrollbar.vue
// module id = Y+KL
// module chunks = 41